import axios from '@/jslib/axios'

export const getLinkList = params => {
  return axios({
    method: 'get',
    url: '/admin/link/statistics/list',
    params
  })
}

export const exportLinkList = params => {
  return axios({
    method: 'get',
    url: '/admin/link/statistics/export',
    responseType: 'blob',
    params,
    timeout: 120000
  })
}